import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'
import classNames from 'classnames';

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { ConstraintStatus } from '../../utils/ConstraintStatus';
import { getNewId } from '../../actions/home.actions';
import { PhaseTag } from '../../models/PhaseTag';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { compose } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { dialogActions } from '../../actions/dialog.actions';
import { connect } from 'react-redux';
import { styles } from '../../containers/dockPadStyle';
const _ = require('lodash')

export interface Props {
    isDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap;

}

type State = {
    
}

class HelpInfoDialog extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
    }

    componentDidMount() {

    }

    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }
    
    render() {
        const { isDialogOpen, classes } = this.props;

        return (
          <Dialog
            maxWidth='sm'
            fullWidth={true}
            open={!!isDialogOpen}
            onBackdropClick={this.closeDialog.bind(this)}
          >
              <DialogContent>
                <div className={classNames(classes.DialogFormTitle, classes.DialogFormHelpInfoTitle)}>
                    <p className={classes.DialogFormTitleText}>
                        Help
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    <table className={classes.DialogHelpTable}>
                    <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+Z</p></td>
                            <td><p className={classes.DialogFormLabel}>Undo</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+X</p></td>
                                <td><p className={classes.DialogFormLabel}>Redo</p></td>
                        </tr>
                    <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+N</p></td>
                            <td><p className={classes.DialogFormLabel}>Creates a tag</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+M</p></td>
                            <td><p className={classes.DialogFormLabel}>Creates a trade</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+C</p></td>
                            <td><p className={classes.DialogFormLabel}>After you click a tag saves a copy of the tag to paste later</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+V</p></td>
                            <td><p className={classes.DialogFormLabel}>After you click a column pastes a copied tag</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+Delete</p></td>
                            <td><p className={classes.DialogFormLabel}>After you highlight tags it gives you the option to delete them</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+D</p></td>
                            <td><p className={classes.DialogFormLabel}>After you highlight tags it gives you the option to duplicate them</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control/Ctrl+R</p></td>
                            <td><p className={classes.DialogFormLabel}>After you highlight a tag it gives you the option to rip it</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Control+S</p></td>
                            <td><p className={classes.DialogFormLabel}>Open Help</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Ctrl/Shift/Control+A</p></td>
                            <td><p className={classes.DialogFormLabel}>Crew Size Display</p></td>
                        </tr>
                        <tr>
                            <td><p className={classes.DialogHelpFormLabel}>Shift/Ctrl+Click and Drag</p></td>
                            <td><p className={classes.DialogFormLabel}>Allows you to select multiple tags</p></td>
                        </tr>
                    </table>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)} color="secondary"> Close </Button>
              </DialogActions>
          </Dialog>
        )
    }
    
}


const mapStateToProps = (state: any) => ({
    isDialogOpen: !!state.dialogReducer.isHelpInfoDialogOpen
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closeHelpInfoDialog()),
    }
};
export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
)(HelpInfoDialog);
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/HelpInfoDialog.tsx